import { FormKitNode } from '@formkit/core';
import { createValidationPlugin, FormKitValidationRule } from '@formkit/validation';

// Inspired by https://github.com/formkit/formkit/blob/master/packages/rules/src/require_one.ts

const rule: FormKitValidationRule = (node: FormKitNode, dependent: string, requiredDependentValue: string) => {
  if (!dependent || !requiredDependentValue) {
    console.warn(
      'requiredIfOtherFieldValue condition is missing dependent field or its value. Skipping this validation.'
    );
    return true;
  }
  const dependentValue: string | undefined | null = node.at(dependent)?.value as string | undefined | null;
  // Check for a field value only if dependent value is set to given string
  return dependentValue !== requiredDependentValue || !!node.value;
};

rule.skipEmpty = false;

export const conditionalRequiredPlugin = createValidationPlugin({
  requiredIfOtherFieldValue: rule,
});
